import React, { Component } from "react";
import { Link } from "react-router-dom";

import Border from "../../Assets/Images/ourMinistries/Publications/blockBorder.jpg";

class GridBlock extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div className="grid-block">{this.blockContent()}</div>;
  }
  blockContent = () => {
    switch (this.props.type) {
      default:
        console.log("type undefined!");
        break;
      case "rawLink":
        return (
          <div>
            <div className="block-content">
              {this.props.image != null ? <img className="preview-img" src={this.props.image} alt="imageSource" /> : null }
              <label>{this.props.title}</label>
            </div>
            <a href={this.props.link}>
              <img style={{ position: "absolute", height: "100%", width: "100%" }} className="block-border" src={Border} alt="blockBorder" />
            </a>
          </div>
        );
      case "routeLink":
        return (
          <div onClick = {() => this.props.updateScrollPos(0)}>
            <div className="block-content">
              {this.props.image != null ? <img className="preview-img" src={this.props.image} alt="imageSource" />: null}
              <label>{this.props.title}</label>
            </div>
            <Link to={this.props.link}>
              <img style={{ position: "absolute", height: "100%", width: "100%" }} className="block-border" src={Border} alt="blockBorder" />
            </Link>
          </div>
        );
    }
  };
}
export default GridBlock;
